import {
    ADD_ARTICLE,
    EDIT_ARTICLE,
    GET_ARTICLES,
    REMOVE_ARTICLE,
    GET_ARTICLE_BY_ID,
} from "../actions/article-actions";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const articleReducer = (state = initialState, action: any): ApiRequestState => {
    switch (action.type) {
        case (ADD_ARTICLE.REQUEST,
        GET_ARTICLES.REQUEST,
        GET_ARTICLE_BY_ID.REQUEST,
        EDIT_ARTICLE.REQUEST,
        REMOVE_ARTICLE.REQUEST):
            return {
                ...state,
                loading: true,
                error: null,
            };
        case (ADD_ARTICLE.SUCCESS,
        GET_ARTICLES.SUCCESS,
        GET_ARTICLE_BY_ID.SUCCESS,
        EDIT_ARTICLE.SUCCESS,
        REMOVE_ARTICLE.SUCCESS):
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case (ADD_ARTICLE.FAILURE,
        GET_ARTICLES.FAILURE,
        GET_ARTICLE_BY_ID.FAILURE,
        EDIT_ARTICLE.FAILURE,
        REMOVE_ARTICLE.FAILURE):
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export { articleReducer };
